import { render, staticRenderFns } from "./Lixeira.vue?vue&type=template&id=50bcb38e&"
import script from "./Lixeira.vue?vue&type=script&lang=js&"
export * from "./Lixeira.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports